module.exports = __webpack_public_path__ + "img/footer_bg.3e9fbba.webp";